import React, { useEffect, useState } from 'react';
import ConfirmBookingModal from './ConfirmBookingModal';
import QtyConfirmationModal from './QtyConfirmationModal';

import { formatNumber } from './utils';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function BookingPage({ items = [], onBookingsChange, onItemsUpdate }) {

  const [bookings, setBookings] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('ALL');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [confirmModal, setConfirmModal] = useState({ open: false, booking: null });
  const [qtyModal, setQtyModal] = useState({ open: false, qty: null, item: null, booking: null });

  useEffect(() => {
    fetch(`${API_URL}/clients`)
      .then(res => res.json())
      .then(setCustomers)
      .catch(() => setCustomers([]));
    setLoading(false);
    setBookings([]);
    setSelectedCustomer('ALL');
    setError('');
    // Removed onBookingsChange([]) to avoid infinite loop
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/bookings`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch bookings');
        return res.json();
      })
      .then(data => {
        // Only keep bookings that are pending (case-insensitive)
        const pending = data.filter(b => String(b.status).toUpperCase() === 'PENDING');
        setBookings(pending);
        if (typeof onBookingsChange === 'function') onBookingsChange(pending.length);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{padding:40}}>Loading bookings...</div>;
  if (error) return <div style={{color:'red',padding:40}}>{error}</div>;

  // Only customers with at least one booking
  const customersWithBookings = customers.filter(c => bookings.some(b => b.clientId === c.id));
  const filteredBookings = selectedCustomer === 'ALL' ? bookings : bookings.filter(b => b.clientId === selectedCustomer);

  return (
    <div>
      <div style={{padding:40}}>
        <h2 style={{color:'#1976d2',fontWeight:800,fontSize:28,marginBottom:24}}>All Bookings</h2>
        <div style={{marginBottom:18,display:'flex',alignItems:'center'}}>
          <span style={{fontWeight:600,marginRight:8}}>Customer:</span>
          <select
            value={selectedCustomer}
            onChange={e => setSelectedCustomer(e.target.value)}
            style={{fontSize:15,borderRadius:8,border:'1px solid #1976d2',padding:'6px 16px',fontWeight:600,color:'#1976d2',background:'#f8fafc',marginLeft:4,outline:'none',boxShadow:'0 1px 6px #1976d211',cursor:'pointer'}}
          >
            <option value="ALL">All Customers</option>
            {customersWithBookings.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
        {Array.isArray(filteredBookings) && filteredBookings.length > 0 ? (
          <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',boxShadow:'0 2px 8px #1976d233',borderRadius:12,overflow:'hidden'}}>
            <thead style={{background:'#f8fafc'}}>
              <tr>
                <th style={{padding:12,textAlign:'left'}}>Work Ticket Nr</th>
                <th style={{padding:12,textAlign:'left'}}>Customer</th>
                <th style={{padding:12,textAlign:'left'}}>Product Code</th>
                <th style={{padding:12,textAlign:'left'}}>Description</th>
                <th style={{padding:12,textAlign:'left'}}>Variant</th>
                <th style={{padding:12,textAlign:'left'}}>Label Size</th>
                <th style={{padding:12,textAlign:'left'}}>Qty</th>
                <th style={{padding:12,textAlign:'left'}}>Current Qty</th>
                <th style={{padding:12,textAlign:'left'}}>Note</th>
                <th style={{padding:12,textAlign:'left'}}>Created</th>
                <th style={{padding:12,textAlign:'left'}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                try {
                  return filteredBookings.map(b => (
                    <tr key={b?.id || Math.random()} style={{borderBottom:'1px solid #e0e0e0'}}>
                      <td style={{padding:10}}>{b?.orderNumber || '-'}</td>
                      <td style={{padding:10}}>{b?.clientName || '-'}</td>
                      <td style={{padding:10}}>{b?.productCode || '-'}</td>
                      <td style={{padding:10}}>{b?.mainCategory || '-'}</td>
                      <td style={{padding:10}}>{b?.variantDesc || '-'}</td>
                      <td style={{padding:10}}>{b?.labelSize || '-'}</td>
                      <td style={{padding:10}}>{b?.quantity != null ? formatNumber(b.quantity) : '-'}</td>
                      <td style={{padding:10}}>{(() => {
                        try {
                          const match = Array.isArray(items) && items.find(i =>
                            (b?.stockItemId && i?.id === b.stockItemId) ||
                            (b?.itemId && i?.id === b.itemId) ||
                            (b?.productCode && i?.productCode === b.productCode)
                          );
                          return match && match.currentQty != null ? formatNumber(match.currentQty) : '-';
                        } catch (e) {
                          return '-';
                        }
                      })()}</td>
                      <td style={{padding:10}}>{b?.note && b.note.length > 20 ? b.note.slice(0, 20) + '…' : (b?.note || '-')}</td>
                      <td style={{padding:10}}>{b?.createdAt ? new Date(b.createdAt).toLocaleString() : '-'}</td>
                      <td style={{padding:10}}>
                        {String(b?.status || '').toUpperCase() === 'PENDING' && (
                          <>
                            <button style={{background:'#43a047',color:'#fff',border:'none',borderRadius:6,padding:'6px 14px',fontWeight:600,marginRight:8}} onClick={() => setConfirmModal({ open: true, booking: b })}>Confirm</button>
                            <button style={{background:'#fb8c00',color:'#fff',border:'none',borderRadius:6,padding:'6px 14px',fontWeight:600}} onClick={() => cancelBooking(b.id)}>Cancel</button>
                          </>
                        )}
                      </td>
                    </tr>
                  ));
                } catch (err) {
                  return <tr><td colSpan={11} style={{color:'red'}}>Error rendering bookings: {String(err)}</td></tr>;
                }
              })()}
            </tbody>
          </table>
        ) : (
          <div style={{padding:20,fontSize:16,color:'#666'}}>No bookings found.</div>
        )}
      </div>
      <ConfirmBookingModal
        open={confirmModal.open}
        booking={confirmModal.booking}
        onClose={() => setConfirmModal({ open: false, booking: null })}
        onConfirm={async (newQty) => {
          if (!confirmModal.booking) return;
          const updatedBooking = await confirmBooking(confirmModal.booking, newQty);
          // Refetch latest items after confirmation
          const itemsRes = await fetch(`${API_URL}/items`);
          const latestItems = await itemsRes.json();
          // Find the matching stock item after confirmation
          const match = latestItems.find(i =>
            (updatedBooking.stockItemId && i.id === updatedBooking.stockItemId) ||
            (updatedBooking.itemId && i.id === updatedBooking.itemId) ||
            (updatedBooking.productCode && i.productCode === updatedBooking.productCode)
          );
          // Show a modal with the remaining qty
          setQtyModal({ open: true, qty: match ? match.currentQty : null, item: match, booking: updatedBooking });
          setConfirmModal({ open: false, booking: null });
        }}
      />
      <QtyConfirmationModal
        open={qtyModal.open}
        qty={qtyModal.qty}
        item={qtyModal.item}
        booking={qtyModal.booking}
        onClose={() => setQtyModal({ open: false, qty: null, item: null, booking: null })}
      />
    </div>
  );

  async function confirmBooking(booking, newQty) {
    try {
      const res = await fetch(`${API_URL}/bookings/${booking.id}/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ qty: newQty })
      });
      if (!res.ok) throw new Error('Failed to confirm booking');
      const updated = await res.json();
      setBookings(bookings => {
        const newBookings = bookings.filter(b => b.id !== updated.id);
        // Call callbacks after state update completes
        setTimeout(() => {
          if (typeof onBookingsChange === 'function') onBookingsChange(newBookings.length);
          if (typeof onItemsUpdate === 'function') onItemsUpdate();
        }, 0);
        return newBookings;
      });
      return updated;
    } catch (err) {
      alert(err.message);
      return booking;
    }
  }

  function cancelBooking(id) {
    if (!window.confirm('Cancel this booking?')) return;
    fetch(`${API_URL}/bookings/${id}/cancel`, { method: 'POST' })
      .then(res => {
        if (!res.ok) throw new Error('Failed to cancel booking');
        return res.json();
      })
      .then(updated => setBookings(bookings => bookings.map(b => b.id === updated.id ? updated : b)))
      .catch(err => alert(err.message));
  }
}
